import { render, staticRenderFns } from "./reportPayFeeDepositList.vue?vue&type=template&id=50a20660&scoped=true"
import script from "./reportPayFeeDepositList.vue?vue&type=script&lang=js"
export * from "./reportPayFeeDepositList.vue?vue&type=script&lang=js"
import style0 from "./reportPayFeeDepositList.vue?vue&type=style&index=0&id=50a20660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a20660",
  null
  
)

export default component.exports